@use "foundation/_responsive_screen_vars.scss";

:share {
  screenXxsMin: responsive_screen_vars.$screen-xxs-min;
  screenXsMin: responsive_screen_vars.$screen-xs-min;
  screenSmMin: responsive_screen_vars.$screen-sm-min;
  screenMdMin: responsive_screen_vars.$screen-md-min;
  screenMlMin: responsive_screen_vars.$screen-ml-min;
  screenLgMin: responsive_screen_vars.$screen-lg-min;
  screenXlMin: responsive_screen_vars.$screen-xl-min;
  screenXxsMax: responsive_screen_vars.$screen-xxs-max;
  screenXsMax: responsive_screen_vars.$screen-xs-max;
  screenSmMax: responsive_screen_vars.$screen-sm-max;
  screenMdMax: responsive_screen_vars.$screen-md-max;
  screenMlMax: responsive_screen_vars.$screen-ml-max;
  screenLgMax: responsive_screen_vars.$screen-lg-max;
}
